import { Frame, Note, useWidgetText } from "../shared";
import type { WidgetProps } from "../types";

/** A widget type this app does not know (DSH-05): the rest of the page still renders. */
export function Placeholder({ widget }: WidgetProps) {
  const { t } = useWidgetText();
  return (
    <Frame widget={widget} state="placeholder">
      <Note>{t("placeholder.update")}</Note>
    </Frame>
  );
}
